import { useEffect, useRef, useState, Suspense, lazy } from "react";
import Section1 from "./Section1";
import Seo from "../../../components/common/Seo";

// Everything below the hero is below-the-fold and not needed for first
// paint / LCP. Each of these also opens its own Firestore onSnapshot
// listener - deferring them means that network work doesn't compete with
// the hero image for bandwidth on a slow connection.
const SectionBreak1 = lazy(() => import("./SectionBreak1"));
const Section2 = lazy(() => import("./Section2"));
const Section3 = lazy(() => import("./Section3"));
const Section4 = lazy(() => import("./Section4"));
const Section5 = lazy(() => import("./Section5"));

// Fallback keeps roughly the section's height so IntersectionObserver /
// scroll math doesn't jump around while a chunk is still loading.
const SectionFallback = () => <div className="min-h-[40vh] w-full" aria-hidden="true" />;

// Dots only appear for the full sections, not the half-height break
const DOT_COUNT = 5;

const Home = () => {
  const [active, setActive] = useState(0);

  // Refs for the five main sections (dots track these)
  const s1Ref = useRef(null);
  const s2Ref = useRef(null);
  const s3Ref = useRef(null);
  const s4Ref = useRef(null);
  const s5Ref = useRef(null);
  const sectionRefs = [s1Ref, s2Ref, s3Ref, s4Ref, s5Ref];

  // IntersectionObserver on the four main sections
  useEffect(() => {
    const observers = sectionRefs.map((ref, i) => {
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) setActive(i);
        },
        { threshold: 0.4 },
      );
      if (ref.current) observer.observe(ref.current);
      return observer;
    });
    return () => observers.forEach((o) => o.disconnect());
  }, []);

  function scrollTo(index) {
    sectionRefs[index].current?.scrollIntoView({ behavior: "smooth" });
    window.__lenis__?.scrollTo(sectionRefs[index].current, {
      duration: 1.4,
      offset: 0,
    });
  }

  return (
    <>
      <Seo
        title="Indoor Sports Complex in Godagama, Homagama, Sri Lanka"
        description="Experience Sri Lanka's premier indoor sports complex in Godagama. Book badminton courts, futsal, indoor cricket, archery, shooting, table tennis, martial arts, and more at Viroosh Sports Complex."
        path="/"
      />
      <div ref={s1Ref}>
        <Section1 />
      </div>
      <Suspense fallback={<SectionFallback />}>
        <SectionBreak1 />
        <div ref={s2Ref}>
          <Section2 />
        </div>
        <div ref={s3Ref} id="promotions">
          <Section3 />
        </div>
         <div ref={s4Ref} id="reviews">
          <Section4 />
        </div>
        <div ref={s5Ref}>
          <Section5 />
        </div>
      </Suspense>

     
    </>
  );
};

export default Home;
